// node-modules
import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded/imagesloaded.pkgd.min';
import PubSub from 'pubsub-js';
import _debounce from 'lodash/debounce';

// constants
import { SELECTORS, EVENTS } from '@/scripts/constants';

// other
import { createEvent } from '@/scripts/utils';

const defaults = {
  el: null,
  filteredContent: '[data-role*="filtered-content"]',
  filteredItem: '[data-role*="filtered-item"]',
  filterItems: '[data-role*="filters-item"]',
  lineController: false,
  transitionDuration: 300,
};
export default class TabFilters {
  constructor(props) {
    const options = Object.assign({}, defaults, props);
    this.el = options.el;
    this.filteredContent = this.el.querySelector(options.filteredContent);
    this.filteredItem = options.filteredItem;
    this.filterItems = Array.from(this.el.querySelectorAll(options.filterItems));
    this.transitionDuration = options.transitionDuration;
    this.lineController = options.lineController;
    this.defaultFilter = '*';
    this.filterBy = '';
    this.grid = null;
    this.activeClass = SELECTORS.active;

    this.updateGrid = this.updateGrid.bind(this);
    this.updateGrid_debounced = _debounce(this.updateGrid, 100);
    this.init();
  }


  initGrid() {
    this.grid = new Isotope(this.filteredContent, {
      itemSelector: this.filteredItem,
      percentPosition: true,
      transitionDuration: this.transitionDuration,
    });
    imagesLoaded(this.filteredContent).on('progress', () => {
      this.grid.layout();
    });
  }

  updateGrid() {
    this.grid.layout();
  }

  initFilters() {
    this.filterItems.forEach((item) => {
      item.addEventListener('click', (e) => {
        if (e) e.preventDefault();
        this.filterBy = item.dataset.filter;
        $(this.filterItems).removeClass(this.activeClass);
        $(item).addClass(this.activeClass);
        if (this.lineController) {
          this.lineController.dispatchEvent(createEvent('updateLine'));
        }
        return this.filter();
      });
    });
  }

  filter() {
    const { filterBy, defaultFilter } = this;
    this.grid.arrange({
      filter(itemElem) {
        const { filterTags } = this ? this.dataset : itemElem.dataset; // ugly hotfix for itemElem is index instead of element
        return filterBy === defaultFilter ? true : filterTags.includes(filterBy);
      },
    });
    window.dispatchEvent(createEvent('resize'));
  }

  destroy() {
    window.removeEventListener('resize', this.updateGrid_debounced);
  }

  init() {
    this.initGrid();
    this.initFilters();
    this.filterItems[0].classList.add(this.activeClass);
    this.filterBy = this.filterItems[0].dataset.filter;
    this.filter();
    window.addEventListener('resize', this.updateGrid_debounced);
    if (this.lineController) this.lineController.dispatchEvent(createEvent('updateLine'));
    PubSub.subscribe(EVENTS.lazyImages_imageLoaded, () => this.grid.layout());
  }
}



// WEBPACK FOOTER //
// ./components/TabFilters/TabFilters.js